<script lang="ts" setup>
import {useTab} from '@/script/common/tabScript';
import {computed, onMounted} from 'vue';

const props = defineProps({
  tabs: {
    default: [{
      name: '',
      value: '',
    }]
  },
  selected: {
    default: ''
  },
  type: {
    default: '',
  }
})

const emits = defineEmits(['update:selected', 'change'])

const {
  toggleTab,
} = useTab()

const updateSelected = (value: string) => {
  toggleTab(value)
  if (value !== props.selected) emits('change', value)
  emits('update:selected', value)
}

const tabClass = (tabName: string) => {
  if (props.selected === tabName) return 'tab-item tab-selected'
  else return 'tab-item'
}

const pageTabClass = computed(() => {
  const className = []
  if (props.type === 'black') className.push('mv-page-tab-black')
  return className.join(' ')
})

onMounted(() => {
  if (!props.selected) {
    toggleTab(props.tabs[0].value)
    emits('update:selected', props.tabs[0].value)
  }
})

</script>

<template>
  <div class="mv-page-tab" :class="pageTabClass">
    <div class="tab-row">
      <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="tabClass(tab.value)"
          @click="updateSelected(tab.value)"
      >
        {{ $t(tab.name) }}
      </div>
    </div>
  </div>
</template>

